import React from 'react';
import styled from 'styled-components';
import colors from 'constants/styles/colors';
import { BodyText } from 'components/typography/bodyText';

const SCardShell = styled.div<{ $isPremium?: boolean }>`
    border-radius: 16px;
    height: 100%;
    ${(p) =>
        p.$isPremium
            ? `
        background: ${colors.orange};
        padding-top: 8px;
    `
            : `
        background: transparent;
        padding-top: 0;
    `}
`;

const SCard = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: ${colors.gray_90};
    border-radius: 16px;
    padding: 24px;
    height: 100%;
    word-break: break-word;
`;

const SCardNumber = styled.div`
    font-weight: 700;
    font-size: 48px;
    line-height: 1;
    letter-spacing: 0.01em;
    color: ${colors.gray_70};
    margin-bottom: 12px;
`;

const SCardTitle = styled.h3`
    font-weight: 700;
    font-size: 36px;
    letter-spacing: 0.01em;
    vertical-align: middle;
    color: ${colors.white};
    margin-bottom: 24px;
`;

const SCardDescriptionWrapper = styled.div`
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
`;

const SCardDescription = styled(BodyText)`
    color: ${colors.white};
`;

interface Props {
    no: string;
    title: string;
    description: string;
    isPremium?: boolean;
}

export const FunctionCard = ({ no, title, description, isPremium }: Props) => {
    return (
        <SCardShell $isPremium={isPremium}>
            <SCard>
                <SCardNumber>{no}</SCardNumber>
                <SCardDescriptionWrapper>
                    <SCardTitle>{title}</SCardTitle>
                    <SCardDescription>{description}</SCardDescription>
                </SCardDescriptionWrapper>
            </SCard>
        </SCardShell>
    );
};
